import { gql } from "@apollo/client";

export const OFFER_TYPES_QUERY = gql`
  query offerTypes {
    offerTypes {
      id
      name
      code
      implicit
    }
  }
`;
